import { render, staticRenderFns } from "./regStudentSearch.vue?vue&type=template&id=839f74d6&scoped=true&"
import script from "./regStudentSearch.vue?vue&type=script&lang=js&"
export * from "./regStudentSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839f74d6",
  null
  
)

export default component.exports